"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralsHttpService = void 0;
const get_recruitment_overview_1 = require("../../types/referrals/get-recruitment-overview");
const get_referral_program_1 = require("../../types/referrals/get-referral-program");
const http_service_1 = require("../http.service");
class ReferralsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/referrals`);
    }
    /** The caller's own tier, filleuls and prime. */
    getProgram() {
        return this.fetch(this.getApiUrlOf('program'), { method: 'GET', schema: get_referral_program_1.getReferralProgramApiResponseSchema }).then(({ data }) => data);
    }
    /**
     * Recommends a confrère. Responds with the refreshed programme, so the
     * filleul list and tier card update from one round-trip.
     */
    submit(payload) {
        return this.fetch(this.getApiUrlOf(''), {
            method: 'POST',
            body: payload,
            schema: get_referral_program_1.getReferralProgramApiResponseSchema,
        }).then(({ data }) => data);
    }
    /** Cities with an Omecare practice, plus cabinet and département counts. */
    getRecruitmentOverview() {
        return this.fetch(this.getApiUrlOf('recruitment-overview'), { method: 'GET', schema: get_recruitment_overview_1.getRecruitmentOverviewApiResponseSchema }).then(({ data }) => data);
    }
}
exports.ReferralsHttpService = ReferralsHttpService;
